// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RtGreenSquareLogo from '../_raw/ui/rt_green_square_logo.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RtGreenSquareLogo, { shouldSetDefaultSize: false });
